import "../css/theme.css";
import { useTheme } from "../OAS365Theme";

export const useCheckinPanelStyle = () => {
    const theme = useTheme();
    const panel = {
        panelStyle: usePanelStyle(theme),
        mainPanelStyle: useMainPanelStyle(theme),
        docRevisionPanelStyle: useDocRevisionPanelStyle(theme),
        buttonPanelStyle: useButtonPanelStyle(theme),
        headerStyle: useTableHeaderStyles(theme),
        buttonSelectedObjStyle: useButtonSelectedObjStyle(theme),
        ObjectConnectionPanelSytle: useObjectConnectionPanelStyle(theme),
    };
    return panel;
};

const usePanelStyle = (theme) => {
    const stackStyles = {
        root: {
            paddingTop: "5px",
            paddingBottom: "10px",
            width: "100%"
        },
    };

    return stackStyles;
};

const useMainPanelStyle = (theme) => {
    const stackStyles = {
        root: {
            position: "relative",
            flexGrow: 1,
            flexShrink: 1,
            minHeight: 0,
            overflow: "hidden",
            background: theme.colors.mainAreaBackgroundColor
        },
    };

    return stackStyles;
};

const useDocRevisionPanelStyle = (theme) => {
    const stackStyles = {
        root: {
            position: "relative",
            flex: "1 1 auto",
            minHeight: 0,
            overflow: "hidden",
            background: theme.colors.mainAreaBackgroundColor,
            paddingBottom: "10px",
        },
    };

    return stackStyles;
};

const useButtonPanelStyle = (theme) => {
    const stackStyles = {
        root: {
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            flexShrink: 0,
            padding: "20px 0px 20px 0px",
        },
    };

    return stackStyles;
};

const useButtonSelectedObjStyle = (theme) => {
    const stackStyles = {
        root: {
            fontFamily: theme.fonts.regular,
            border: theme.colors.backgroundColor,
            fontSize: "12px",
            padding: "0px",
            margin: "0px",
            backgroundColor: theme.colors.backgroundColor,
            selectors: {
                ".ms-Button-label": {
                    margin: "0px 0px",
                    color: theme.colors.fontColor,
                },
                ".ms-Button-flexContainer": {
                    backgroundColor: theme.colors.backgroundColor,
                },
                ".ms-Button-flexContainer:hover": {
                    backgroundColor: theme.colors.backgroundColor,
                },

                ".ms-Button ms-Button--primary": {
                    border: `0px solid  ${theme.colors.themeDarkColor} !important`,
                    backgroundColor: theme.colors.backgroundColor,

                },
                ".ms-Button:hover": {
                    border: theme.colors.backgroundColor,
                    backgroundColor: theme.colors.backgroundColor,
                },
                "&.ms-Button--primary:hover": {
                    backgroundColor: theme.colors.backgroundColor,
                    border: `1px solid  ${theme.colors.themeDarkColor} !important`,
                }
            },
        },
    };

    return stackStyles;
};

const useObjectConnectionPanelStyle = (theme) => {
    const stackStyles = {
        root: {
            width: "70%",
            //minWidth: "950px",
            align: "center",
        },
    };

    return stackStyles;
};

const useTableHeaderStyles = (theme) => {
    const stackStyles = {
        root: {
            alignItems: "center",
            // color: "",
            display: "flex",
            justifyContent: "center",
            overflow: "hidden",
            lineHeight: "22px",
            fontFamily: theme.fonts.regular,
            fontSize: theme.fontSizes.large,
            lineHeight: theme.fontSizes.header,
            fontWeight: theme.fontWeight.titleWeight,
        },
    };

    return stackStyles;
};
